import { createFileRoute } from '@tanstack/react-router';
import { Alert, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PlatformRole, hasRole, useSession } from '../auth/session';
import { EnquiriesScreen } from '../features/enquiries/EnquiriesScreen';

/**
 * Enquiries from the public site. Platform-level: an enquiry belongs to no tenant, which is rather
 * the point of one. The API enforces the same bar; this only decides what to render.
 */
export const Route = createFileRoute('/enquiries')({
  // `?id=` is how the notification email links to one enquiry. Optional, and ignored when it names
  // something that no longer exists, so an old link opens the queue rather than an error.
  validateSearch: (search: Record<string, unknown>): { id?: string } => ({
    id: typeof search.id === 'string' && search.id.length > 0 ? search.id : undefined,
  }),
  component: EnquiriesPage,
});

function EnquiriesPage() {
  const { t } = useTranslation('enquiries');
  const { data: session } = useSession();
  const { id } = Route.useSearch();

  if (!hasRole(session, PlatformRole.MspAdmin)) {
    return (
      <Stack gap="md" maw={560}>
        <Alert color="red" title={t('noAccessTitle')}>
          {t('noAccessBody')}
        </Alert>
      </Stack>
    );
  }

  return <EnquiriesScreen highlightId={id ?? null} />;
}
